
export function typePer(data1) {
    var sign = sessionStorage.getItem("dictData");
    var signs = JSON.parse(sign);
    var typelist = signs.sys_person_type;
    typelist.forEach(item => {
      item.label = item.name;
      item.value = item.DID;
    });
    typelist.forEach(item => {
        if (data1 == item.type) {
           data1 = item.label;
        }
    });
    return data1 
}




// WEBPACK FOOTER //
// ./src/utils/type.js